import { Box, styled } from "@mui/material";

interface StyledWrapperProps {
  isSelected?: boolean;
  isDisabled?: boolean;
}

export const StyledWrapper = styled(Box, {
  shouldForwardProp: (prop: string) =>
    !["isSelected", "isDisabled"].includes(prop),
})<StyledWrapperProps>`
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: all 0.15s;

  ${({ theme: { wsc }, isSelected }) => `
    background-color: ${wsc.palette.neutral[isSelected ? 500 : 700]};
    padding: ${wsc.spacing[2]};
    color: ${wsc.palette.neutral[100]};
    height: calc(${wsc.size.l} * 3);
    border-radius: ${wsc.radius.m};
    gap: calc(${wsc.spacing[1]} * 2.5);
    border: calc(${wsc.size.xs} / 4) solid ${
      isSelected ? wsc.palette.neutral[300] : "transparent"
    };

    &:hover {
      background-color: ${wsc.palette.neutral[isSelected ? 500 : 600]};
    }
  `}

  ${({ theme: { wsc }, isDisabled }) =>
    isDisabled &&
    `
    background-color: ${wsc.palette.neutral[700]};
    cursor: initial;
    color: ${wsc.palette.neutral[400]};

    &:hover {
      background-color: ${wsc.palette.neutral[700]};
    }
  `}
`;

export const StyledCardText = styled("span")`
  display: flex;
  flex: 1;

  ${({ theme: { wsc } }) => wsc.typography.body1};
`;
